<template>
  <div class="member-invite-done">

    <div class="header-container">
      <img class="header-background" :src="require('@/assets/half-round-header-background.svg')">
      <div class="title-container">
        <div class="title">מעולה,
עשית את הצעד הראשון שלך
בדרך לצמיחה כלכלית!
        </div>
      </div>
    </div>

    <div class="content">
      <div class="title">{{ firstName }},
      אנחנו שמחים שהצטרפת לriseup!</div>
      <div class="bot">הבוט של riseup מחכה לך ב-WhatsApp.</div>
      <div class="see-ya">נתראה שם! 👋</div>
      <support-footer />
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import Segment from '../../../../../Segment';

export default {
  name: 'MemberInviteDone',
  components: {
    SupportFooter: BaseUI.SupportFooter,
  },
  data() {
    return {
      gotAnswer: false,
      phoneNumber: '',
      code: '',
    };
  },
  async created() {
    Segment.trackUserGot('MemberInviteDoneEntered');
  },
  computed: {
    ...mapState('memberInvite', ['firstName']),
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .member-invite-done {
    font-family: SimplerPro;
    width: 100%;

    .header-container {
      position: relative;
      margin-bottom: 30px;

      .header-background {
        width: 100%;
      }

      .title-container {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        height: 100%;
        align-items: center;

        .title {
          display: inline-block;
          @include title;
          line-height: 32px;
          padding: 0 30px;
          white-space: pre-wrap;
          color: $riseup_white;
        }
      }
    }

    .content {
      margin: 0 30px;

      .title {
        @include title;
        line-height: 26px;
        margin-bottom: 10px;
      }

      .bot {
        margin-bottom: 20px;
        line-height: 24px;
      }

      .see-ya {
        font-weight: bold;
        margin-bottom: 30px;
      }
    }
  }
</style>
